export class dataLayer {
  static push (options: Record<string, any>) {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push(options)
  }
}
